var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyus9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.07,
    y: 80.54,
    width: 183.66,
    height: 123.66,
    rx: 13.42,
    ry: 13.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.07,
    y: 100.45,
    width: 183.66,
    height: 29.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 69.78,
    y: 178.48,
    width: 45.94,
    height: 11.07,
    rx: 5.01,
    ry: 5.01
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 34.95,
    y: 120.68,
    width: 183.66,
    height: 123.66,
    rx: 13.42,
    ry: 13.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.95,
    y: 140.6,
    width: 183.66,
    height: 29.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 50.66,
    y: 218.63,
    width: 45.94,
    height: 11.07,
    rx: 5.01,
    ry: 5.01
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.57,190.69l10.11-6.06c1.22-.73,2.73-.73,3.95,0l13.95,8.36c1.22,.73,2.73,.73,3.95,0l13.95-8.36c1.22-.73,2.73-.73,3.95,0l13.95,8.36c1.22,.73,2.73,.73,3.95,0l13.95-8.36c1.22-.73,2.73-.73,3.95,0l10.11,6.06c2.56,1.53,5.81-.31,5.81-3.29V68.07c0-9.15-7.42-16.57-16.57-16.57h-107.34l16.51,65.77v70.13c0,2.98,3.26,4.83,5.81,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.25,51.5h0c9.11,0,16.51,7.4,16.51,16.51v74.43c0,1.46-1.19,2.65-2.65,2.65h-27.72c-1.46,0-2.65-1.19-2.65-2.65V68c0-9.11,7.4-16.51,16.51-16.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 185.49,
    y: 80.68,
    width: 60.59,
    height: 8.14,
    rx: 4.07,
    ry: 4.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 185.49,
    y: 110.38,
    width: 60.59,
    height: 8.14,
    rx: 4.07,
    ry: 4.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 185.49,
    y: 140.08,
    width: 60.59,
    height: 8.14,
    rx: 4.07,
    ry: 4.07
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus9);
export default __webpack_public_path__ + "static/media/whyus9.7110c798d613df4cadf64a7627ddf2f5.svg";
export { ForwardRef as ReactComponent };